// CSS Modules - component class name: LanguageSwitcher__

<template>
  <div
    v-show="!loading"
    :class="$style.select"
    v-on:mouseenter="
      options.length > 1 && !isMobileDevice && $refs.switcher.activate()
    "
    v-on:mouseleave="
      options.length > 1 && !isMobileDevice && $refs.switcher.deactivate()
    "
  >
    <multiselect
      ref="switcher"
      v-if="options.length > 1"
      v-model="value"
      :options="options"
      :searchable="false"
      :show-labels="false"
      :allow-empty="false"
      :hide-selected="true"
      :preselectFirst="true"
    >
      <template slot="singleLabel" slot-scope="props">
        <Flag :flag="props.option.img" class="option__image" />
        <span class="option__title">{{ props.option.title }}</span>
      </template>
      <template slot="option" slot-scope="props">
        <Flag :flag="props.option.img" class="option__image" />
        <div class="option__desc">
          <span @click="switchLanguage(props.option.url)" class="option__title">
            {{ props.option.title }}
          </span>
        </div>
      </template>
    </multiselect>
    <div :class="$style.noSelect" v-if="options.length < 2">
      <img :src="this.options[0].img" alt="" />
      <span>{{ this.options[0].title }}</span>
    </div>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import Multiselect from "vue-multiselect";
import Flag from "../Flag/Flag";

export default {
  name: "LanguageSwitcher",
  components: { Multiselect, Flag },
  props: {
    options: {
      type: Array,
      default: () => [{ title: "", img: "", url: "" }]
    }
  },
  data() {
    return {
      loading: true,
      value: "",
      isMobileDevice: isMobile
    };
  },
  methods: {
    customLabel({ title }) {
      return `${title}`;
    },
    switchLanguage(url) {
      window.location.href = url;
    }
  },
  mounted() {
    this.loading = false;
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style module lang="scss">
@import "./LanguageSwitcher.scss";
</style>
